/*
 * Sleep2Care — same-day shipping cutoff messaging.
 *
 * Cutoff: 13.30 in Europe/Copenhagen time. Weekdays only (no weekend dispatch).
 *
 * Markup contract (any combination — JS just looks for these data attributes):
 *   <span data-s2c-cutoff-timer>3t 42m</span>      — countdown to cutoff (today)
 *   <span data-s2c-cutoff-prefix>Bestil inden for</span>
 *   <span data-s2c-cutoff-suffix>...</span>        — dispatch wording
 *   [data-s2c-cutoff-bar]                          — wrapper that gets state class
 *
 * State classes added to the wrapper:
 *   .is-cutoff-today     — Mon-Fri before 13.30 (timer ticks)
 *   .is-cutoff-tomorrow  — Mon-Thu after cutoff, or Sunday (next dispatch is tomorrow)
 *   .is-cutoff-monday    — Friday after cutoff, Saturday (next dispatch is Monday)
 *
 * Static fallback inside the markers will simply not get replaced if JS fails —
 * it's always safe to ship a sensible default in the HTML.
 */
(function () {
  if (window.__s2cCutoffBound) return;
  window.__s2cCutoffBound = true;

  var CUTOFF_MIN = 13 * 60 + 30; // 13.30 in minutes since midnight

  function cphParts() {
    // toLocaleString in en-GB gives DD/MM/YYYY, HH:MM:SS — easy to parse.
    var s = new Date().toLocaleString('en-GB', {
      timeZone: 'Europe/Copenhagen',
      hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var m = s.match(/(\d+)\/(\d+)\/(\d+),?\s+(\d+):(\d+):(\d+)/);
    if (!m) return null;
    var year = +m[3], month = +m[2] - 1, day = +m[1];
    return {
      hour: +m[4], minute: +m[5], second: +m[6],
      // UTC-anchored Date is sufficient to compute day-of-week from y/m/d.
      dow: new Date(Date.UTC(year, month, day)).getUTCDay()
    };
  }

  function fmtTimer(mins) {
    if (mins <= 0) return '';
    var h = Math.floor(mins / 60), m = mins % 60;
    if (h === 0) return m + ' min.';
    if (m === 0) return h + 't';
    return h + 't ' + (m < 10 ? '0' : '') + m + 'm';
  }

  function compute() {
    var p = cphParts();
    if (!p) return null;
    var nowMin = p.hour * 60 + p.minute;
    var isWeekday = p.dow >= 1 && p.dow <= 5;
    var beforeCutoff = nowMin < CUTOFF_MIN;

    if (isWeekday && beforeCutoff) {
      return { kind: 'today', remaining: CUTOFF_MIN - nowMin };
    }
    // After cutoff or weekend — figure out next dispatch label.
    if (p.dow >= 1 && p.dow <= 4) return { kind: 'tomorrow' };  // Mon-Thu after cutoff
    if (p.dow === 5 || p.dow === 6) return { kind: 'monday' };  // Fri after / Sat
    return { kind: 'tomorrow' };                                 // Sun → Mon is "i morgen"
  }

  function setText(selector, text) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.textContent = text;
    });
  }

  function update() {
    var s = compute();
    if (!s) return;

    // Wrapper state class
    document.querySelectorAll('[data-s2c-cutoff-bar]').forEach(function (el) {
      el.classList.remove('is-cutoff-today', 'is-cutoff-tomorrow', 'is-cutoff-monday');
      el.classList.add('is-cutoff-' + s.kind);
    });

    if (s.kind === 'today') {
      setText('[data-s2c-cutoff-prefix]', 'Bestil inden for');
      setText('[data-s2c-cutoff-timer]', fmtTimer(s.remaining));
      setText('[data-s2c-cutoff-suffix]', '— afsendes i dag fra vores lager.');
    } else if (s.kind === 'tomorrow') {
      setText('[data-s2c-cutoff-prefix]', 'Bestil nu');
      setText('[data-s2c-cutoff-timer]', '');
      setText('[data-s2c-cutoff-suffix]', '— afsendes i morgen fra vores lager.');
    } else {
      // monday
      setText('[data-s2c-cutoff-prefix]', 'Bestil nu');
      setText('[data-s2c-cutoff-timer]', '');
      setText('[data-s2c-cutoff-suffix]', '— afsendes mandag fra vores lager.');
    }
  }

  function init() {
    update();
    // Refresh once a minute so the countdown ticks and the message rolls over
    // at 13:30 / midnight without a page reload.
    setInterval(update, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
